<template>
  <div>
    <div class="grid-x grid">
      <div class="cell small-12 medium-4" v-for="item in items" :key="'news-' + item.id">
        <news-item
          :item="item"
          :colour="colour"
        />
      </div>
    </div>
    <pagination
      v-if="!singlePage"
      :total-pages="maxPages"
      :current-page.sync="currentPage"
      @update:current-page="changePage"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import NewsItem from '@/components/NewsItem.vue';
  import Pagination from '@/components/Pagination.vue';

  export default {
    props: {
      homeSlug: String,
      colour: String,
      singlePage: {
        type: Boolean,
        default: false
      }
    },
    components: {
      NewsItem,
      Pagination
    },
    data() {
      return {
        currentPage: 1
      }
    },
    mounted() {
      this.grabNewsPage();
    },
    methods: {
      ...mapActions(['fetchNewsPage']),
      grabNewsPage() {
        this.fetchNewsPage({
          home: this.homeSlug,
          page: this.currentPage
        })
      },
      changePage() {
        this.grabNewsPage();
      }
    },
    computed: {
      ...mapGetters({
        maxPages: 'getNewsMaxPages'
      }),
      items() {
        return this.$store.getters.getNewsPage(this.currentPage).length ?
          this.$store.getters.getNewsPage(this.currentPage) :
          this.placeholders;
      },
      placeholders() {
        let placeholders = [];
        for (var i = 1; i <= 3; i++) {
          placeholders.push({
            id: i,
            title: '-------',
            card: {
              text: '---------<br>---------<br>---------<br>---------<br>---------<br>---------<br>',
              image: ''
            }
          });
        }
        return placeholders;
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'foundation-sites/scss/foundation.scss';
  @import '@/assets/scss/_settings';
  .grid {
    margin: vw-relative(48 -16 0);
  }
</style>
